module.exports = __webpack_public_path__ + "img/banner-web-3.192c4ab8.jpg";